import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, imageSlot, text } from "./kit";
import type { LabelTemplate } from "./types";

// Split: the visitor's logo on the left, the name and a few lines set flush
// left in a column on the right, the place centred at the foot. (No vertical
// rule between them: a box can be no narrower than 3 mm.)
function wine(): CanvasData {
  const b = "wine";
  const col = { x: 44, width: 40, align: "left" as const };
  return doc(b, INK["warm-white"], [
    imageSlot({ x: 6, y: 33, width: 30, height: 30 }, "Your logo"),
    text({ ...col, text: "YOUR", font: "cinzel", size: 5, color: INK.charcoal, baseline: 43, tracking: 0.12 }),
    text({ ...col, text: "NAME", font: "cinzel", size: 5, color: INK.charcoal, baseline: 50.5, tracking: 0.12 }),
    text({ ...col, text: "Est. 2026", font: "cormorant", italic: true, size: 2.6, color: INK.charcoal, baseline: 57.5, tracking: 0.04 }),
    text({ ...col, text: "Private Cellar", font: "montserrat", size: 1.6, color: INK.charcoal, baseline: 63.5, tracking: 0.2 }),
    centred(b, { text: "Stellenbosch", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 90, tracking: 0.2 }),
  ]);
}

export const logoSplit: LabelTemplate = {
  key: "logo-split",
  name: "Split",
  occasion: "modern",
  style: "Logo left, words right",
  description: "Your logo on the left, your name set flush left beside it.",
  hasImageSlot: true,
  slot: "logo",
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
